import createTheme from '@mui/material/styles/createTheme';
import { darkTheme as darkThemeParams } from '@/styles/theme/darkTheme/darkTheme';
import { defaultTheme } from '@/styles/theme/defaultTheme/defaultTheme';

export const theme = createTheme(defaultTheme);
export const darkTheme = createTheme(defaultTheme, darkThemeParams);
